import { render, staticRenderFns } from "./LiveModeWarning.vue?vue&type=template&id=c00a455e"
import script from "./LiveModeWarning.vue?vue&type=script&lang=js"
export * from "./LiveModeWarning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports